import type { JSX } from "react";
import type { Services } from "../../../../services/services";
import type { CommonNavItemProps } from "./common-nav-item-props";
import { useServices } from "../../../../services/services-context";
import { NavButton } from "./nav-button";


export type NavItemActionProps = CommonNavItemProps & {
	kind: "action";
	action: (services: Services) => void;
};
export const NavItemAction = ({ icon, labelKey, action, slim }: NavItemActionProps): JSX.Element => {
	const services = useServices();

	return (
		<NavButton
			labelKey={ labelKey }
			icon={ icon }
			onClick={ () => action(services) }
			slim={ slim }
		/>
	);
};